import { useState, useEffect } from 'react';
import {
  isNotificationSupported,
  getNotificationPermission,
  requestNotificationPermission,
} from '../lib/browserNotifications.js';

/**
 * Hook para manejar notificaciones del navegador
 * @returns {Object} Estado y funciones de notificaciones
 */
export function useBrowserNotifications() {
  const [permission, setPermission] = useState(getNotificationPermission());
  const [isSupported] = useState(isNotificationSupported());

  // Actualizar estado del permiso cuando cambie
  useEffect(() => {
    if (!isSupported) return;

    const handlePermissionChange = () => {
      setPermission(getNotificationPermission());
    };

    // Escuchar cambios en el permiso (algunos navegadores lo soportan)
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: 'notifications' }).then((result) => {
        result.addEventListener('change', handlePermissionChange);
        return () => result.removeEventListener('change', handlePermissionChange);
      });
    }
  }, [isSupported]);

  /**
   * Solicita permiso al usuario
   */
  const requestPermission = async () => {
    const newPermission = await requestNotificationPermission();
    setPermission(newPermission);
    return newPermission;
  };

  return {
    isSupported,
    permission,
    isGranted: permission === 'granted',
    isDenied: permission === 'denied',
    isDefault: permission === 'default',
    requestPermission,
  };
}
